export const contato = {
  hero: {
    label: 'Contact',
    title: 'Contact FGT Capital',
    subtitle: 'Get in touch to schedule a strategic diagnosis or clarify questions about wealth engineering.',
  },
  info: {
    title: 'Contact Information',
    location: {
      label: 'Location',
      value: 'São Paulo/SP – Brazil',
    },
    whatsapp: {
      label: 'WhatsApp',
      value: '+55 11 93032-2408',
    },
    email: {
      label: 'Email',
      value: 'contato@fgt-capital.com',
    },
    hours: {
      label: 'Hours',
      value: 'Monday to Friday, 9am to 6pm',
    },
  },
  form: {
    title: 'Send a Message',
    fields: {
      name: 'Full Name',
      email: 'Email',
      whatsapp: 'WhatsApp',
      message: 'Message',
      characters: 'characters',
    },
    submit: 'Send Message',
    submitting: 'Sending...',
    success: 'Message sent successfully! We will get back to you soon.',
    error: 'Error sending message. Please try again or contact us via WhatsApp.',
  },
};